/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback } from 'react'
import '../assets/css/style.css'
import headerLogo from '../assets/img/logo/header_logo.svg'
import { Link } from 'react-router-dom'
import { useDealerCodeUrl } from '../hook/useDealerCode'

export const Header = React.memo(() => {
  const [isOpen, changeOpen] = useState(false)

  const handleClick = useCallback(() => {
    changeOpen(!isOpen)
  }, [isOpen])

  return (
    <header className="l-header">
      <div className="l-header__top">
        <div className="l-header__top__inner">
          <h1 className="l-header__top__logo">
            <Link to={useDealerCodeUrl('/')} onClick={() => handleClick()}>
              <img src={headerLogo} alt="今こそ資産運用を考えよう" width="280" height="24" />
            </Link>
          </h1>
          <span
            className="l-header__menu-trigger js-menutrigger"
            onClick={() => handleClick()}
          ></span>
        </div>
      </div>

      <div className="l-header__menu" style={{ display: isOpen ? 'block' : 'none' }}>
        <div className="l-header__menu__content">
          <nav className="l-header__nav-wrap">
            <ul className="l-header__nav--primary">
              <li>資産運用をはじめよう</li>
              <li>
                <Link to={useDealerCodeUrl('/shisan')} onClick={() => handleClick()}>
                  資産運用<span>超低金利がつづく今だから</span>
                </Link>
              </li>
              <li>
                <Link to={useDealerCodeUrl('/rougo')} onClick={() => handleClick()}>
                  老後資金<span>何から始めればいいの？</span>
                </Link>
              </li>
              <li>
                <Link to={useDealerCodeUrl('/kyouiku')} onClick={() => handleClick()}>
                  教育資金<span>どのくらい準備する？</span>
                </Link>
              </li>
            </ul>
            <ul className="l-header__nav--secondary u-mt50px">
              <li>知っておきたい投資のコトバ</li>
              <li>
                <Link to={useDealerCodeUrl('/toushin')} onClick={() => handleClick()}>
                  投資信託とは
                </Link>
              </li>
              <li>
                <Link to={useDealerCodeUrl('/tsumitate')} onClick={() => handleClick()}>
                  つみたて投資とは
                </Link>
              </li>
              <li>
                <a href="https://www.nomura-am.co.jp/nisa/" target="_blank" rel="noopener">
                  はじめるならNISA
                </a>
              </li>
            </ul>
            <ul className="l-header__nav--secondary u-mt50px">
              <li>資産運用に役立つ便利ツール</li>
              <li>
                <Link to={useDealerCodeUrl('/calc')} onClick={() => handleClick()}>
                  つみたてシミュレーション
                </Link>
              </li>
              <li>
                <Link to={useDealerCodeUrl('/simulation')} onClick={() => handleClick()}>
                  将来シミュレーション
                </Link>
              </li>
              <li>
                <Link to={useDealerCodeUrl('/reversal')} onClick={() => handleClick()}>
                  取り崩しシミュレーション
                </Link>
              </li>
              <li>
                <Link to={useDealerCodeUrl('/rougoSimulation')} onClick={() => handleClick()}>
                  老後資金シミュレーション
                </Link>
              </li>
            </ul>
            <ul className="l-header__nav--tertiary u-mt80px">
              <li>
                <Link to={useDealerCodeUrl('/')} onClick={() => handleClick()}>
                  TOP
                </Link>
              </li>
              <li>
                <a href="https://www.nomura-am.co.jp/" target="_blank" rel="noopener noreferrer">
                  野村アセットマネジメント ホームページ
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="l-header__menu__overlay js-menutrigger" onClick={() => handleClick()}></div>
      </div>
    </header>
  )
})
